import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "p-grid p-m-2" }
const _hoisted_3 = { class: "p-col-4 p-d-flex p-flex-row p-ai-center" }
const _hoisted_4 = { class: "kn-flex" }
const _hoisted_5 = { class: "kn-material-input-label" }
const _hoisted_6 = { class: "p-col-2 p-d-flex p-flex-row p-ai-center" }
const _hoisted_7 = { class: "kn-flex" }
const _hoisted_8 = { class: "kn-material-input-label" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "qbe-filter-option-value" }
const _hoisted_11 = { class: "p-ml-2" }
const _hoisted_12 = { class: "kn-material-input-label" }
const _hoisted_13 = {
  key: 0,
  class: "p-col-2 p-d-flex p-flex-row p-ai-center"
}
const _hoisted_14 = { class: "kn-flex" }
const _hoisted_15 = { class: "kn-material-input-label" }
const _hoisted_16 = {
  key: 1,
  class: "p-col-4 p-d-flex p-flex-row p-ai-center"
}
const _hoisted_17 = { class: "kn-flex" }
const _hoisted_18 = { class: "p-d-flex p-flex-row p-ai-center" }
const _hoisted_19 = {
  key: 0,
  class: "p-d-flex p-flex-row p-ai-center p-mt-3"
}
const _hoisted_20 = { class: "p-float-label" }
const _hoisted_21 = { class: "kn-material-input-label" }
const _hoisted_22 = { class: "p-mx-2" }
const _hoisted_23 = { class: "p-float-label" }
const _hoisted_24 = { class: "kn-material-input-label" }
const _hoisted_25 = {
  key: 1,
  class: "kn-width-full"
}
const _hoisted_26 = { class: "kn-material-input-label" }
const _hoisted_27 = { key: 3 }
const _hoisted_28 = { class: "kn-flex p-d-flex p-flex-row p-m-1" }
const _hoisted_29 = {
  key: 0,
  class: "kn-flex p-d-flex p-flex-row p-m-1"
}
const _hoisted_30 = {
  key: 4,
  class: "qbe-filter-chip-container p-d-flex p-flex-row p-ai-center p-flex-wrap kn-flex"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Chips = _resolveComponent("Chips")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Chip = _resolveComponent("Chip")
  const _component_q_item_section = _resolveComponent("q-item-section")
  const _component_q_icon = _resolveComponent("q-icon")
  const _component_q_item = _resolveComponent("q-item")
  const _component_q_list = _resolveComponent("q-list")
  const _component_q_menu = _resolveComponent("q-menu")
  const _component_q_btn = _resolveComponent("q-btn")
  const _component_q_input = _resolveComponent("q-input")
  const _component_QBEFilterValuesTable = _resolveComponent("QBEFilterValuesTable")
  const _directive_tooltip = _resolveDirective("tooltip")
  const _directive_close_popup = _resolveDirective("close-popup")

  return (_ctx.filter)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("common.field")), 1),
              _createVNode(_component_InputText, {
                class: "kn-material-input",
                modelValue: _ctx.filter.leftOperandDescription,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.leftOperandDescription = $event)),
                disabled: true
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _withDirectives(_createVNode("label", _hoisted_8, [
                _createTextVNode(_toDisplayString(_ctx.$t("qbe.filters.condition")), 1)
              ], 512), [
                [
                  _directive_tooltip,
                  _ctx.$t('qbe.filters.conditionTooltip'),
                  void 0,
                  { top: true }
                ]
              ]),
              _createVNode(_component_Dropdown, {
                class: "kn-material-input",
                modelValue: _ctx.filter.operator,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter.operator = $event)),
                options: _ctx.filterOperatorOptions,
                optionValue: "value",
                onChange: _ctx.onFilterOperatorChange
              }, {
                value: _withCtx((slotProps) => [
                  (slotProps.value)
                    ? (_openBlock(), _createBlock("div", _hoisted_9, [
                        _createVNode("span", _hoisted_10, _toDisplayString(_ctx.getFilterOperatorLabel(slotProps.value)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                option: _withCtx((slotProps) => [
                  _createVNode("div", null, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t(slotProps.option.label)), 1)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "options", "onChange"])
            ]),
            _withDirectives(_createVNode("div", _hoisted_11, [
              _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("common.parameter")), 1),
              _createVNode(_component_InputText, {
                class: "kn-material-input",
                modelValue: _ctx.filter.operatorParameter,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filter.operatorParameter = $event))
              }, null, 8, ["modelValue"])
            ], 512), [
              [_vShow, _ctx.filter.operator === 'SPATIAL_NN']
            ])
          ]),
          (_ctx.filter.operator !== 'IS NULL' && _ctx.filter.operator !== 'NOT NULL')
            ? (_openBlock(), _createBlock("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, [
                  _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("qbe.filters.targetType")), 1),
                  _createVNode(_component_Dropdown, {
                    class: "kn-material-input",
                    modelValue: _ctx.filter.rightType,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filter.rightType = $event)),
                    options: ['STARTS WITH', 'NOT STARTS WITH', 'ENDS WITH', 'NOT ENDS WITH', 'CONTAINS', 'NOT CONTAINS', 'BETWEEN', 'NOT BETWEEN'].includes(_ctx.filter.operator) ? [_ctx.targetValues[0]] : _ctx.targetValues,
                    optionValue: "value",
                    optionLabel: "label",
                    onChange: _ctx.onFilterTypeChange
                  }, null, 8, ["modelValue", "options", "onChange"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.filter.operator !== 'IS NULL' && _ctx.filter.operator !== 'NOT NULL')
            ? (_openBlock(), _createBlock("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, [
                  _withDirectives(_createVNode("label", { class: "kn-material-input-label" }, _toDisplayString(_ctx.$t("qbe.filters.target")), 513), [
                    [_vShow, !(_ctx.filter.rightType === 'manual' && ['BETWEEN', 'NOT BETWEEN', 'IN', 'NOT IN'].includes(_ctx.filter.operator))]
                  ]),
                  _createVNode("div", _hoisted_18, [
                    (_ctx.filter.rightType === 'manual' && ['BETWEEN', 'NOT BETWEEN'].includes(_ctx.filter.operator) && _ctx.field.dataType !== 'java.sql.Timestamp' && _ctx.field.dataType !== 'java.sql.Date')
                      ? (_openBlock(), _createBlock("div", _hoisted_19, [
                          _createVNode("div", _hoisted_20, [
                            _createVNode(_component_InputText, {
                              class: "kn-material-input",
                              modelValue: _ctx.firstOperand,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.firstOperand = $event)),
                              onInput: _ctx.onManualBetweenChange
                            }, null, 8, ["modelValue", "onInput"]),
                            _createVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("qbe.filters.lowLimit")), 1)
                          ]),
                          _createVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("qbe.filters.and")), 1),
                          _createVNode("div", _hoisted_23, [
                            _createVNode(_component_InputText, {
                              class: "kn-material-input",
                              modelValue: _ctx.secondOperand,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.secondOperand = $event)),
                              onInput: _ctx.onManualBetweenChange
                            }, null, 8, ["modelValue", "onInput"]),
                            _createVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("qbe.filters.highLimit")), 1)
                          ])
                        ]))
                      : (_ctx.filter.rightType === 'manual' && ['IN', 'NOT IN'].includes(_ctx.filter.operator) && _ctx.field.dataType !== 'java.sql.Timestamp' && _ctx.field.dataType !== 'java.sql.Date')
                        ? (_openBlock(), _createBlock("div", _hoisted_25, [
                            _createVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("qbe.filters.enterValue")), 1),
                            _createVNode(_component_Chips, {
                              class: "kn-material-input",
                              modelValue: _ctx.multiManualValues,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.multiManualValues = $event)),
                              onAdd: _ctx.onManualMultivalueChanged,
                              onRemove: _ctx.onManualMultivalueChanged,
                              addOnBlur: true
                            }, null, 8, ["modelValue", "onAdd", "onRemove"])
                          ]))
                        : (_ctx.filter.rightType === 'manual' && _ctx.field.dataType !== 'java.sql.Timestamp' && _ctx.field.dataType !== 'java.sql.Date')
                          ? (_openBlock(), _createBlock(_component_InputText, {
                              key: 2,
                              class: "kn-material-input",
                              modelValue: _ctx.filter.rightOperandDescription,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.filter.rightOperandDescription = $event)),
                              onInput: _ctx.onManualValueChange
                            }, null, 8, ["modelValue", "onInput"]))
                          : (_ctx.filter.rightType === 'manual' && (_ctx.field.dataType === 'java.sql.Timestamp' || _ctx.field.dataType === 'java.sql.Date'))
                            ? (_openBlock(), _createBlock("div", _hoisted_27, [
                                _createVNode("div", _hoisted_28, [
                                  _createVNode(_component_Calendar, {
                                    class: "kn-flex p-mr-2",
                                    modelValue: _ctx.targetDate,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.targetDate = $event)),
                                    onInput: _ctx.onManualTimestampChange,
                                    onDateSelect: _ctx.onManualTimestampChange
                                  }, null, 8, ["modelValue", "onInput", "onDateSelect"]),
                                  (_ctx.field.dataType === 'java.sql.Timestamp')
                                    ? (_openBlock(), _createBlock(_component_Calendar, {
                                        key: 0,
                                        class: "qbe-filter-time-input",
                                        modelValue: _ctx.targetDate,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.targetDate = $event)),
                                        manualInput: true,
                                        timeOnly: true,
                                        hourFormat: "24",
                                        onInput: _ctx.onManualTimestampChange,
                                        onDateSelect: _ctx.onManualTimestampChange
                                      }, null, 8, ["modelValue", "onInput", "onDateSelect"]))
                                    : _createCommentVNode("", true)
                                ]),
                                (['BETWEEN', 'NOT BETWEEN'].includes(_ctx.filter.operator))
                                  ? (_openBlock(), _createBlock("div", _hoisted_29, [
                                      _createVNode(_component_Calendar, {
                                        class: "kn-flex p-mr-2",
                                        modelValue: _ctx.targetEndDate,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.targetEndDate = $event)),
                                        onInput: _ctx.onManualTimestampChange,
                                        onDateSelect: _ctx.onManualTimestampEndDateChange
                                      }, null, 8, ["modelValue", "onInput", "onDateSelect"]),
                                      (_ctx.field.dataType === 'java.sql.Timestamp')
                                        ? (_openBlock(), _createBlock(_component_Calendar, {
                                            key: 0,
                                            class: "qbe-filter-time-input",
                                            modelValue: _ctx.targetEndDate,
                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.targetEndDate = $event)),
                                            manualInput: true,
                                            timeOnly: true,
                                            hourFormat: "24",
                                            onInput: _ctx.onManualTimestampEndDateChange,
                                            onDateSelect: _ctx.onManualTimestampChange
                                          }, null, 8, ["modelValue", "onInput", "onDateSelect"]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_ctx.filter.rightType === 'valueOfField')
                              ? (_openBlock(), _createBlock("div", _hoisted_30, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedValues, (selectedValue, index) => {
                                    return (_openBlock(), _createBlock(_component_Chip, {
                                      key: index,
                                      class: "p-mr-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(selectedValue), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                    (_ctx.filter.rightType === 'anotherEntity')
                      ? (_openBlock(), _createBlock(_component_q_input, {
                          key: 5,
                          class: "col",
                          dense: "",
                          readonly: "",
                          modelValue: _ctx.filter.rightOperandDescription,
                          "onUpdate:modelValue": [
                            _cache[13] || (_cache[13] = ($event: any) => (_ctx.filter.rightOperandDescription = $event)),
                            _ctx.onEntityTypeChanged
                          ],
                          label: _ctx.$t('qbe.filters.target')
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_q_btn, {
                              round: "",
                              flat: "",
                              icon: "search"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_menu, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_list, {
                                      dense: "",
                                      style: {"min-width":"100px"}
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.entities, (entity) => {
                                          return (_openBlock(), _createBlock(_component_q_item, {
                                            clickable: "",
                                            key: entity.id
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_q_item_section, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(entity.text), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_q_item_section, { side: "" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_q_icon, { name: "keyboard_arrow_right" })
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_q_menu, {
                                                anchor: "top end",
                                                self: "top start"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_q_list, null, {
                                                    default: _withCtx(() => [
                                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(entity.children, (child) => {
                                                        return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                                          key: child.id,
                                                          dense: "",
                                                          clickable: "",
                                                          onClick: ($event: any) => (_ctx.filter.rightOperandDescription = child.attributes.longDescription)
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_q_item_section, null, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(child.text), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onClick"])), [
                                                          [_directive_close_popup]
                                                        ])
                                                      }), 128))
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                      : _createCommentVNode("", true),
                    (_ctx.filter.rightType === 'subquery')
                      ? (_openBlock(), _createBlock(_component_Dropdown, {
                          key: 6,
                          class: "kn-material-input kn-flex",
                          modelValue: _ctx.filter.rightOperandDescription,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.filter.rightOperandDescription = $event)),
                          options: _ctx.subqueries,
                          optionValue: "name",
                          optionLabel: "name",
                          onChange: _ctx.onSubqeryTargetChange
                        }, null, 8, ["modelValue", "options", "onChange"]))
                      : _createCommentVNode("", true),
                    (_ctx.filter.rightType === 'parameter')
                      ? (_openBlock(), _createBlock(_component_Dropdown, {
                          key: 7,
                          class: "kn-material-input kn-flex",
                          modelValue: _ctx.filter.rightOperandDescription,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.filter.rightOperandDescription = $event)),
                          options: _ctx.parameters,
                          optionValue: "name",
                          optionLabel: "name",
                          onChange: _ctx.onParameterTargetChange
                        }, null, 8, ["modelValue", "options", "onChange"]))
                      : _createCommentVNode("", true),
                    (_ctx.filter.rightType === 'valueOfField')
                      ? (_openBlock(), _createBlock("i", {
                          key: 8,
                          class: "fa fa-check kn-cursor-pointer p-ml-2",
                          onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.loadFilterValues && _ctx.loadFilterValues(...args)))
                        }))
                      : _createCommentVNode("", true),
                    _createVNode("i", {
                      class: "fa fa-eraser kn-cursor-pointer p-ml-2",
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$emit('removeFilter', _ctx.filter)))
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createVNode(_component_QBEFilterValuesTable, {
          class: "p-m-2",
          filterValuesData: _ctx.filterValuesData,
          loadedSelectedValues: _ctx.selectedValues,
          loading: _ctx.loading,
          filterOperator: _ctx.filter.operator,
          onSelected: _ctx.setSelectedValues
        }, null, 8, ["filterValuesData", "loadedSelectedValues", "loading", "filterOperator", "onSelected"]), [
          [_vShow, _ctx.filter.rightType === 'valueOfField']
        ])
      ]))
    : _createCommentVNode("", true)
}